module.exports = __webpack_public_path__ + "static/media/33000132.0670cc31.png";